"use client";

import React, { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";

import styles from "./popup.module.scss";
import Button from "../button/button";

interface PopupProps {
  children: string | ReactNode;
  title?: string;
  buttonText?: string;
  show: boolean;
  onButtonClicked?: (() => void) | null;
}

const Popup: React.FC<PopupProps> = ({
  children,
  title = "Title",
  buttonText = "OK",
  show,
  onButtonClicked,
}) => {
  const popupContainer = document.getElementById("popup");

  useEffect(() => {
    if (show) {
      popupContainer?.classList.add("show__");
      popupContainer?.classList.remove("hide__");
    } else {
      popupContainer?.classList.add("hide__");
      popupContainer?.classList.remove("show__");
    }
  }, [show]);

  return (
    popupContainer &&
    createPortal(
      <div
        className={`${styles.popupContentContainer} ${
          show ? styles.show__ : styles.hide__
        }`}
      >
        {title && <div className={styles.titleContainer}>{title}</div>}
        {children}
        {onButtonClicked && (
          <Button onClick={onButtonClicked}>{buttonText}</Button>
        )}
      </div>,
      popupContainer
    )
  );
};

export default Popup;
